// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"3b51520f","819":"2a1d4c82"}[chunkId] + ".chunk.js";
};